import React, { useMemo } from "react";
import { RiskStatusIcon, Section } from "@sscs/ui";
import { capitalizeFirstLetter, getClassName } from "@sscs/utils";
import { ASSESSMENT_TYPE_TO_TITLE } from "../../../../constants";
import RenderChildrenWrapper from "../../../common/RenderChildrenWrapper";
import PercentageBars from "../PercentageBars/PercentageBars";
import { getRiskEvaluationsCounters, sortRiskEvaluations } from "../utils";
import styles from "./assessmentCard.module.scss";
const AssessmentCard = ({ assessmentCategory, riskAssessment, policyCount, policiesWrapper, risksWrapper, }) => {
    const sortedRiskEvaluations = useMemo(() => [
        // Winning evaluation should always be first
        {
            violations: riskAssessment.violations,
            label: riskAssessment.label,
            status: riskAssessment.status,
            count: riskAssessment.count,
            priority: riskAssessment.priority,
        },
        ...sortRiskEvaluations(riskAssessment.evaluations),
    ], [riskAssessment]);
    const riskEvaluationsCounters = useMemo(() => getRiskEvaluationsCounters(sortedRiskEvaluations), [sortedRiskEvaluations]);
    const maxTopRisks = 3;
    const topRisksCount = Math.min(sortedRiskEvaluations.length, maxTopRisks);
    const otherRisksCount = sortedRiskEvaluations.length - topRisksCount;
    const hasPassStatus = riskAssessment.status === "pass";
    const isCategoryDisabled = !riskAssessment.enabled;
    const categoryTitle = ASSESSMENT_TYPE_TO_TITLE[assessmentCategory];
    const otherRisks = (React.createElement(React.Fragment, null,
        "+",
        otherRisksCount.toLocaleString(),
        " other risk",
        otherRisksCount !== 1 ? "s" : "",
        " in ",
        categoryTitle));
    return (React.createElement(Section, { className: getClassName({
            [styles.disabled]: isCategoryDisabled,
        }) },
        isCategoryDisabled && (React.createElement("div", { className: styles.entitlement },
            categoryTitle,
            " assessment is available in the\u00A0",
            React.createElement("strong", null, "Spectra Assure Enterprise+"),
            "\u00A0tier.")),
        React.createElement(Section.Title, { as: "h3" },
            React.createElement("span", { className: styles.title },
                React.createElement(RiskStatusIcon, { status: riskAssessment.status, disabled: isCategoryDisabled }),
                categoryTitle)),
        React.createElement(Section.Action, null,
            React.createElement("div", { className: styles.policies },
                React.createElement(RenderChildrenWrapper, { wrapper: policiesWrapper &&
                        ((children) => policiesWrapper("enabled", children)) },
                    policyCount.evaluated.toLocaleString(),
                    " evaluated polic",
                    policyCount.evaluated === 1 ? "y" : "ies"),
                policyCount.disabled > 0 && (React.createElement(React.Fragment, null,
                    " · ",
                    React.createElement(RenderChildrenWrapper, { wrapper: policiesWrapper &&
                            ((children) => policiesWrapper("disabled", children)) },
                        policyCount.disabled.toLocaleString(),
                        " disabled"))))),
        React.createElement(Section.Content, null,
            React.createElement(PercentageBars, { riskEvaluationCounters: riskEvaluationsCounters, totalEvaluatedPolicies: policyCount.evaluated }),
            React.createElement("div", { className: styles.caused },
                React.createElement("div", { className: styles["caused-header"] },
                    React.createElement("span", { className: styles["caused-label"] }, "\u21B3 Caused"),
                    !hasPassStatus && (React.createElement(RenderChildrenWrapper, { wrapper: risksWrapper &&
                            ((children) => risksWrapper({ type: "total", children })) },
                        sortedRiskEvaluations.length.toLocaleString(),
                        " ",
                        capitalizeFirstLetter(assessmentCategory),
                        " Risk",
                        sortedRiskEvaluations.length !== 1 ? "s" : ""))),
                sortedRiskEvaluations
                    .slice(0, topRisksCount)
                    .map((riskStats, index) => {
                    const isReproRisk = riskStats.label
                        .toLowerCase()
                        .includes("reproducibility");
                    return (React.createElement("div", { className: styles["risk-item"], key: index },
                        !hasPassStatus && (React.createElement(RiskStatusIcon, { status: riskStats.status, size: "xs", disabled: false })),
                        riskStats.count > 0 ? (React.createElement(RenderChildrenWrapper, { wrapper: risksWrapper &&
                                ((children) => risksWrapper({
                                    type: "label",
                                    children,
                                    riskStats,
                                    isReproRisk,
                                })) },
                            React.createElement("span", null, capitalizeFirstLetter(riskStats.label)))) : (React.createElement("span", null, riskStats.label))));
                }),
                otherRisksCount > 0 && (React.createElement(RenderChildrenWrapper, { wrapper: risksWrapper &&
                        ((children) => risksWrapper({ type: "other", children })) },
                    React.createElement("div", { className: styles["other-risks"] }, otherRisks)))))));
};
export default AssessmentCard;
//# sourceMappingURL=AssessmentCard.js.map